import { resolveSchemaWithRef } from './resolve-schema-with-ref';
export const getItemFromSchema = (schema, definitions) => {
    var _a;
    const resolvedSchema = resolveSchemaWithRef(schema, definitions);
    const defaultValue = resolvedSchema.default;
    const properties = (_a = resolvedSchema.properties) !== null && _a !== void 0 ? _a : {};
    const required = Array.isArray(resolvedSchema.required) ? resolvedSchema.required : [];
    switch (resolvedSchema.type) {
        case 'string':
            return defaultValue !== null && defaultValue !== void 0 ? defaultValue : '';
        case 'boolean':
            return defaultValue !== null && defaultValue !== void 0 ? defaultValue : false;
        case 'number':
            return defaultValue !== null && defaultValue !== void 0 ? defaultValue : 0;
        case 'object':
            return Object.entries(properties).reduce((acc, [key, value]) => {
                if (required.includes(key)) {
                    acc[key] = getItemFromSchema(value, definitions);
                }
                return acc;
            }, {});
        default:
            return {};
    }
};
//# sourceMappingURL=get-item-from-schema.js.map